/**
 * Implements an about section placeholder
 */
import Skeleton from 'react-loading-skeleton';

interface IAboutPlaceholderProps {
  graph?: boolean;
  price?: boolean;
  largeDescription?: boolean;
}

const AboutPlaceholder = ({
  graph,
  price,
  largeDescription,
}: IAboutPlaceholderProps) => {
  return (
    <div className='seo_page__about_token__content'>
      <div className='seo_page__hero_section'>
        <div className='seo_page__hero_section__head'>
          <div className='seo_page__hero_section__info'>
            <div className='seo_page__hero_section__coin'>
              <Skeleton width={56} height={56} circle />
              <div className='seo_page__hero_section__coin__title'>
                <div className='box'>
                  <Skeleton width={150} height={32} />
                </div>
                {price && (
                  <div className='box'>
                    <Skeleton width={150} height={24} />
                  </div>
                )}
              </div>
            </div>
            {price && (
              <div className='seo_page__hero_section__currency'>
                <Skeleton width={160} height={16} />
                <Skeleton width={160} height={32} />
              </div>
            )}
          </div>
          {graph && (
            <div className='seo_page__hero_section__graph'>
              <Skeleton height={474} />
            </div>
          )}
        </div>
      </div>
      <div className='seo_page__about_section'>
        <Skeleton height={largeDescription ? 232 : 20} />
        {largeDescription && (
          <Skeleton width={110} height={36} style={{ marginTop: 8 }} />
        )}
      </div>
    </div>
  );
};

export default AboutPlaceholder;
